import { Visit } from '../components/Visit/Visit'

export const VisitPage = () => {
    return <Visit />
}
